import { ArrowClockwise } from '@phosphor-icons/react/dist/ssr/ArrowClockwise';
import { ArrowDown } from '@phosphor-icons/react/dist/ssr/ArrowDown';
import { ArrowDownLeft } from '@phosphor-icons/react/dist/ssr/ArrowDownLeft';
import { ArrowRight } from '@phosphor-icons/react/dist/ssr/ArrowRight';
import { ArrowsClockwise } from '@phosphor-icons/react/dist/ssr/ArrowsClockwise';
import { ArrowsLeftRight } from '@phosphor-icons/react/dist/ssr/ArrowsLeftRight';
import { ArrowUp } from '@phosphor-icons/react/dist/ssr/ArrowUp';
import { ArrowUpRight } from '@phosphor-icons/react/dist/ssr/ArrowUpRight';
import { BellSimple } from '@phosphor-icons/react/dist/ssr/BellSimple';
import { BracketsCurly } from '@phosphor-icons/react/dist/ssr/BracketsCurly';
import { CalendarBlank } from '@phosphor-icons/react/dist/ssr/CalendarBlank';
import { CaretCircleRight } from '@phosphor-icons/react/dist/ssr/CaretCircleRight';
import { CaretDown } from '@phosphor-icons/react/dist/ssr/CaretDown';
import { CaretLeft } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import { CaretRight } from '@phosphor-icons/react/dist/ssr/CaretRight';
import { CaretUp } from '@phosphor-icons/react/dist/ssr/CaretUp';
import { CaretUpDown } from '@phosphor-icons/react/dist/ssr/CaretUpDown';
import { CellSignalFull } from '@phosphor-icons/react/dist/ssr/CellSignalFull';
import { CellSignalLow } from '@phosphor-icons/react/dist/ssr/CellSignalLow';
import { CellSignalMedium } from '@phosphor-icons/react/dist/ssr/CellSignalMedium';
import { CellSignalSlash } from '@phosphor-icons/react/dist/ssr/CellSignalSlash';
import { ChartBar } from '@phosphor-icons/react/dist/ssr/ChartBar';
import { Check } from '@phosphor-icons/react/dist/ssr/Check';
import { CheckCircle } from '@phosphor-icons/react/dist/ssr/CheckCircle';
import { Circle } from '@phosphor-icons/react/dist/ssr/Circle';
import { CircleHalf } from '@phosphor-icons/react/dist/ssr/CircleHalf';
import { Clock } from '@phosphor-icons/react/dist/ssr/Clock';
import { ClockClockwise } from '@phosphor-icons/react/dist/ssr/ClockClockwise';
import { Coins } from '@phosphor-icons/react/dist/ssr/Coins';
import { Copy } from '@phosphor-icons/react/dist/ssr/Copy';
import { CreditCard } from '@phosphor-icons/react/dist/ssr/CreditCard';
import { CurrencyCircleDollar } from '@phosphor-icons/react/dist/ssr/CurrencyCircleDollar';
import { Database } from '@phosphor-icons/react/dist/ssr/Database';
import { DiscordLogo } from '@phosphor-icons/react/dist/ssr/DiscordLogo';
import { Dot } from '@phosphor-icons/react/dist/ssr/Dot';
import { DotsThreeVertical } from '@phosphor-icons/react/dist/ssr/DotsThreeVertical';
import { DownloadSimple } from '@phosphor-icons/react/dist/ssr/DownloadSimple';
import { ExclamationMark } from '@phosphor-icons/react/dist/ssr/ExclamationMark';
import { Eye } from '@phosphor-icons/react/dist/ssr/Eye';
import { EyeSlash } from '@phosphor-icons/react/dist/ssr/EyeSlash';
import { FileText } from '@phosphor-icons/react/dist/ssr/FileText';
import { Fire } from '@phosphor-icons/react/dist/ssr/Fire';
import { Gauge } from '@phosphor-icons/react/dist/ssr/Gauge';
import { GearSix } from '@phosphor-icons/react/dist/ssr/GearSix';
import { Info } from '@phosphor-icons/react/dist/ssr/Info';
import { Intersect } from '@phosphor-icons/react/dist/ssr/Intersect';
import { Lightning } from '@phosphor-icons/react/dist/ssr/Lightning';
import { LightningSlash } from '@phosphor-icons/react/dist/ssr/LightningSlash';
import { Link } from '@phosphor-icons/react/dist/ssr/Link';
import { List } from '@phosphor-icons/react/dist/ssr/List';
import { ListMagnifyingGlass } from '@phosphor-icons/react/dist/ssr/ListMagnifyingGlass';
import { Lock } from '@phosphor-icons/react/dist/ssr/Lock';
import { LockOpen } from '@phosphor-icons/react/dist/ssr/LockOpen';
import { MagnifyingGlass } from '@phosphor-icons/react/dist/ssr/MagnifyingGlass';
import { MapPinSimple } from '@phosphor-icons/react/dist/ssr/MapPinSimple';
import { MathOperations } from '@phosphor-icons/react/dist/ssr/MathOperations';
import { Minus } from '@phosphor-icons/react/dist/ssr/Minus';
import { NavigationArrow } from '@phosphor-icons/react/dist/ssr/NavigationArrow';
import { Newspaper } from '@phosphor-icons/react/dist/ssr/Newspaper';
import { PencilSimple } from '@phosphor-icons/react/dist/ssr/PencilSimple';
import { Plus } from '@phosphor-icons/react/dist/ssr/Plus';
import { Power } from '@phosphor-icons/react/dist/ssr/Power';
import { Prohibit } from '@phosphor-icons/react/dist/ssr/Prohibit';
import { Pulse } from '@phosphor-icons/react/dist/ssr/Pulse';
import { PushPin } from '@phosphor-icons/react/dist/ssr/PushPin';
import { Question } from '@phosphor-icons/react/dist/ssr/Question';
import { ShareFat } from '@phosphor-icons/react/dist/ssr/ShareFat';
import { ShuffleSimple } from '@phosphor-icons/react/dist/ssr/ShuffleSimple';
import { SketchLogo } from '@phosphor-icons/react/dist/ssr/SketchLogo';
import { Sparkle } from '@phosphor-icons/react/dist/ssr/Sparkle';
import { Star } from '@phosphor-icons/react/dist/ssr/Star';
import { TelegramLogo } from '@phosphor-icons/react/dist/ssr/TelegramLogo';
import { Timer } from '@phosphor-icons/react/dist/ssr/Timer';
import { Users } from '@phosphor-icons/react/dist/ssr/Users';
import { Vault } from '@phosphor-icons/react/dist/ssr/Vault';
import { Wallet } from '@phosphor-icons/react/dist/ssr/Wallet';
import { Warning } from '@phosphor-icons/react/dist/ssr/Warning';
import { WarningCircle } from '@phosphor-icons/react/dist/ssr/WarningCircle';
import { X } from '@phosphor-icons/react/dist/ssr/X';
import { XCircle } from '@phosphor-icons/react/dist/ssr/XCircle';
import { XLogo } from '@phosphor-icons/react/dist/ssr/XLogo';
import { IconBaseProps, IconComponent } from './types';

export const Icons = {
  ArrowClockwise,
  ArrowDown,
  ArrowDownLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  ArrowsClockwise,
  ArrowsLeftRight,
  BellSimple,
  BracketsCurly,
  CalendarBlank,
  CaretDown,
  CaretDownFill: (props: IconBaseProps) => (
    <CaretDown weight="fill" {...props} />
  ),
  CaretLeft,
  CaretRight,
  CaretRightFill: (props: IconBaseProps) => (
    <CaretRight weight="fill" {...props} />
  ),
  CaretUp,
  CaretUpDownFill: (props: IconBaseProps) => (
    <CaretUpDown weight="fill" {...props} />
  ),
  CaretUpFill: (props: IconBaseProps) => <CaretUp weight="fill" {...props} />,
  CaretCircleRight,
  CellSignalFull,
  CellSignalLow,
  CellSignalMedium,
  CellSignalSlash,
  ChartBar,
  Check,
  CheckBold: (props: IconBaseProps) => <Check weight="bold" {...props} />,
  CheckCircle,
  Circle,
  CircleFill: (props: IconBaseProps) => <Circle weight="fill" {...props} />,
  CircleHalfFill: (props: IconBaseProps) => (
    <CircleHalf weight="fill" {...props} />
  ),
  Clock,
  ClockClockwise,
  Coins,
  Copy,
  CreditCard,
  CurrencyCircleDollar,
  Database,
  DiscordLogo,
  Dot,
  DotsThreeVertical,
  DownloadSimple,
  ExclamationMark,
  Eye,
  EyeSlash,
  FileText,
  FireFill: (props: IconBaseProps) => <Fire weight="fill" {...props} />,
  Gauge,
  GearSix,
  Info,
  Intersect,
  LightningFill: (props: IconBaseProps) => (
    <Lightning weight="fill" {...props} />
  ),
  LightningSlash,
  Link,
  List,
  ListMagnifyingGlass,
  Lock,
  LockOpen,
  MagnifyingGlass,
  MapPinSimple,
  MathOperationsBold: (props: IconBaseProps) => (
    <MathOperations weight="bold" {...props} />
  ),
  Minus,
  NavigationArrowFill: (props: IconBaseProps) => (
    <NavigationArrow weight="fill" {...props} />
  ),
  Newspaper,
  PencilSimple,
  Plus,
  Power,
  Prohibit,
  Pulse,
  PushPin,
  Question,
  SketchLogo,
  ShareFatFill: (props: IconBaseProps) => <ShareFat weight="fill" {...props} />,
  ShuffleSimple,
  Sparkle,
  SparkleFill: (props: IconBaseProps) => <Sparkle weight="fill" {...props} />,
  Star,
  StarFill: (props: IconBaseProps) => <Star weight="fill" {...props} />,
  TelegramLogo,
  Timer,
  Users,
  Vault,
  Wallet,
  WalletFill: (props: IconBaseProps) => <Wallet weight="fill" {...props} />,
  Warning,
  WarningCircle,
  X,
  XCircle,
  XLogo,
} as const satisfies Record<string, IconComponent>;
